var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"pd30"},[_c('div',[_c('card-list',{attrs:{"member_id":_vm.member_id}})],1),_c('div',{staticClass:"mt20"},[_c('record-list',{attrs:{"member_id":_vm.member_id}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }